import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import ContentPageHero from '../components/ContentPageHero';
import Services from '../components/Services';
import GoverningBodies from '../components/GoverningBodies';
import Comparison from '../components/Comparison';
import Footer from '../components/Footer';

const ServicesPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Services | PH Therapy</title>
        <meta name="description" content="Exercise physiology, oncology rehabilitation, and corporate wellness for partners and CEOs. MSK, cancer, and lifestyle management. London, Wimbledon, Fulham, Kensington, Chiswick, Surrey & Sussex." />
        <link rel="canonical" href="https://www.pandhtherapy.co.uk/services" />
      </Helmet>
      <Header />
      <ContentPageHero
        title="Our Services"
        description="Expert exercise physiology, cancer rehabilitation, corporate wellness, and lifestyle management. Bespoke programmes for partners, CEOs, and professionals across London, Wimbledon, Fulham, Kensington, Chiswick, Surrey, and Sussex."
        backgroundImage={`${process.env.PUBLIC_URL}/TeamImage.JPG`}
      />
      <Services />
      <GoverningBodies />
      <Comparison />
      <Footer />
    </>
  );
};

export default ServicesPage;